<script lang="ts" setup>
	import { cn } from '~/utils/functions'

	const { defaultClass = '' } = defineProps<{
		note?: string
		defaultClass?: string
		iconClass?: string
		iconName?: string
		iconDir?: string
		iconWidth?: number
		iconHeight?: number
		ui?: {
			wrapper?: string
			container?: string
			iconWrapper?: string
			icon?: string
			text?: string
		}
	}>()

	const defaultUi = {
		wrapper:
			'w-full inline-flex items-center relative rounded-lg border border-gray-200 text-gray-600 font-normal py-3 px-2 text-sm',
		container: 'w-full inline-flex gap-2 items-start',
		iconWrapper: 'text-orange-500 text-sm font-normal leading-none flex-none flex items-center justify-center',
		text: 'leading-[20px] tracking-wide'
	}
</script>

<template>
	<div :class="cn(defaultUi.wrapper, defaultClass, ui?.wrapper)">
		<div :class="cn(defaultUi.container, ui?.container)">
			<div :class="cn(defaultUi.iconWrapper, ui?.iconWrapper, iconClass)">
				<slot name="icon">
					<lazy-tools-icon
						:dir="iconDir || 'fill'"
						:icon="iconName || 'warning'"
						:height="iconHeight || 20"
						:width="iconWidth || 20"
						:path-class="ui?.icon"
					/>
				</slot>
			</div>
			<span :class="cn(defaultUi.text, ui?.text)">
				<slot>
					{{ note }}
				</slot>
			</span>
		</div>
	</div>
</template>
